import { datasource } from "./datasource";

export const appUserProshopDS = (currentUserId, actions) => () =>
  datasource(currentUserId, actions)("app_user_proshop", {
    model: {
      id: "id",
      auditable: true,
      syncable: true,
      byProshop: true,
      fields: {
        id: {
          type: "string",
        },
        role_id: {
          type: "string",
        },
        proshop_id: {
          type: "string",
        },
        user_id: {
          type: "number",
        },
        created_at: {
          type: "string",
        },
        updated_at: {
          type: "string",
        },
        created_by: {
          type: "string",
        },
        updated_by: {
          type: "string",
        },
      },
    },
  });
